/** @format */

import { User } from "../../auth/authSlice";
import { api } from "./api";

export type UserRole = undefined | "teacher" | "wjec";

export type UserSubRole = undefined | "admin" | "dlo";

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    /**
     * gets the current user
     * @returns the fetched user.
     */
    getMe: build.query<User, void>({
      query: () => "me",
      providesTags: ["User"],
    }),
  }),
});

export const { useGetMeQuery } = userApi;
